/**
 * 存储模块初始化
 * 提供注册存储服务的便捷方法
 *
 * 核心功能：
 * 1. 自动注册所有存储服务
 * 2. 确保依赖注入正确配置
 * 3. 提供简化的应用初始化接口
 */
import { StorageFactory } from './factory.service.js';
import { LoggerService } from '../logging/services/logger.service.js';
/**
 * 初始化存储服务
 * 注册所有存储服务实例到依赖注入系统
 *
 * 应在应用启动时调用
 */
export async function initializeStorageServices() {
    const logger = LoggerService.getInstance();
    try {
        // 使用工厂服务初始化所有存储服务
        await StorageFactory.initializeAll();
    }
    catch (error) {
        logger.error('[Storage] Failed to initialize storage services', { error });
        throw new Error('Failed to initialize storage services: ' +
            (error instanceof Error ? error.message : String(error)));
    }
}
/**
 * 默认导出初始化函数
 */
export default initializeStorageServices;
//# sourceMappingURL=initialize.js.map